<template>
  <div :class="[
    'form-item',
    `form-item--${type}`,
    type !== 'checkbox' && type !== 'radio' ? `form-item--text` : '',
    type === 'select' ? 'form-item--icon' : '',
    type === 'search' ? 'form-item--icon' : '',
    type === 'search' ? 'form-item--icon-search' : '',
    icon ? `form-item--icon form-item--icon-${icon}` : '',
  ]"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'FormItem',
  props: {
    type: {
      type: String,
      default: 'text',
      required: false,
      validator: value => [
        'text',
        'password',
        'email',
        'select',
        'radio',
        'checkbox',
        'search',
      ].indexOf(value) !== -1,
    },
    icon: {
      type: String,
      required: false,
      default: null,
    },
  },
};
</script>

<style scoped lang="scss">
.form-item {
  line-height: 1.75;
  margin-bottom: 1rem;
  &--select {
    &:after {
      content: $icon-angle-down;
    }
  }
  &--icon {
    position: relative;
    &:after {
      @include iconfont($icomoon-font-family);
      position: absolute;
      right: 1.5rem;
      top: 50%;
      transform: translateY(-50%);
      pointer-events: none;
      color: $gray-400;
    }
  }
  $field-search-width: 4.5rem;
  &--search {
    align-items: center;
    border: .1rem solid $gray-300;
    display: flex;
    .form-item__input {
      border: none;
    }
    &__button {
      background-color: $color-purple--100;
      border: none;
      color: $gray-500;
      font-size: 2.3rem;
      height: 100%;
      padding: 0;
      position: absolute;
      right: 0;
      width: $field-search-width;
    }
  }
  &__input {
    border-radius: 0;
    &::placeholder {
      color: $gray-400;
    }
    &:focus,
    &:active {
      outline: .2rem solid $color-secondary;
    }
    &--full-width {
      width: 100%;
    }
    &--text {
      border: .1rem solid $gray-300;
      padding: .8rem $field-search-width + 0.8rem .8rem 1rem;
      -webkit-appearance: unset;
    }
    &--radio-checkbox {
      position: absolute;
      opacity: 0;
      &:focus {
        + label {
          &:before {
            outline: .2rem solid $color-secondary;
          }
        }
      }
      &:checked {
        + label {
          &:before {
            background: $color-primary;
          }
          &:after {
            @include iconfont($icomoon-font-family);
            color: $white;
            content: $icon-check;
            font-size: 1.4rem;
            left: .5rem;
            position: absolute;
            top: .7rem;
          }
        }
      }
      &:disabled {
        + label {
          color: $gray-200;
          cursor: auto;
          &:before {
            box-shadow: none;
            background: rgba($gray-200, .4);
          }
        }
      }
      + label {
        $checkbox-size: 2rem;
        position: relative;
        cursor: pointer;
        padding: 0;
        margin: 0 0 .5rem 0;
        &:before {
          border: .1rem solid $gray-200;
          content: '';
          margin-right: $checkbox-size / 2;
          display: inline-block;
          vertical-align: text-top;
          width: $checkbox-size;
          height: $checkbox-size;
          background: $white;
          margin-left: 2px;
        }
      }
    }
  }
  &__input-label {
    i {
      margin-right: .5rem;
      font-size: 1.4rem;
    }
  }
}
</style>
